import { useLocation, useNavigate } from "react-router-dom";
import { ActionTypes } from "../../redux/type";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoggedIn } from "../../redux/reducers/auth-reducer";
import { endUserSession } from "../../utils/analyticsTracker";
import { toast } from "react-toastify";
import { logOutFromServer } from "../../redux/actions/auth-action";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MapIcon from '@mui/icons-material/Map';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import { setView } from "../../redux/reducers/ui-reducer";
import "./sidebar.css";

const Sidebar = ({
  issidebar,
  islogin,
  onChangeRoute = (e: any) => { },
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useSelector((s: any) => s.auth.loginDetails);
  const allState = useSelector((state: any) => state);
  const view = useSelector((state: any) => state.ui?.view || "Dashboard");

  // Leave at once; the server call can take long when the API is busy.
  const handleLogout = () => {
    const details = allState?.auth?.loginDetails?.user_details?.[0];
    logOutFromServer({ refresh_token: details?.refresh_token }, details?.access_token);
    localStorage.removeItem("loginAt");
    dispatch(setIsLoggedIn(false));
    dispatch({ type: ActionTypes.GLOBAL_RESET, payload: undefined });
    endUserSession(userDetails);
    navigate("/");
    toast.success('Logout Successfully', {
      position: "top-right",
      autoClose: 3000,
      theme: "light"
    });
  };

  const handleView = (viewName: string, path: string) => {
    dispatch(setView(viewName));
    onChangeRoute(viewName);
    // Dashboard and Map are views of the same screen. Navigating to "/"
    // redirects back to /dashboard and remounts it, which drops the fleet
    // list and waits on the slow devices API again.
    if (!location.pathname.startsWith("/dashboard")) navigate(path);
  };

  return (
    <div className={`navrail ${issidebar ? "navrail--expanded" : "navrail--collapsed"}`}>
      <div
        className="navrail-row"
        onClick={() => handleView("Dashboard", "/")}
      >
        <div className="navrail-icon-wrap">
          <DensityMediumIcon className={`navrail-icon ${view === 'Dashboard' ? 'navrail-icon--active' : ''}`} />
        </div>
      </div>

      <div
        className="navrail-row"
        onClick={() => handleView("Map", "/")}
      >
        <div className="navrail-icon-wrap">
          <MapIcon className={`navrail-icon ${view === 'Map' ? 'navrail-icon--active' : ''}`} />
        </div>
      </div>


      {allState?.auth?.loginDetails?.role === "admin" && (
        <>
          <div
            className="navrail-row"
            onClick={() => handleView("UserManagement", "/user-management")}
          >
            <div className="navrail-icon-wrap">
              <GroupAddIcon className={`navrail-icon ${view === 'UserManagement' ? 'navrail-icon--active' : ''}`} />
            </div>
          </div>
        </>
      )}

      <div
        className="navrail-row navrail-row--logout"
        onClick={handleLogout}
      >
        <div className="navrail-icon-wrap">
          <ExitToAppIcon className="navrail-icon" />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;